import { LogLevel } from '@azure/msal-browser'

const devLogging = {
  loggerOptions: {
    loggerCallback: (level, message, containsPii) => {
      if (containsPii) {
        return
      }
      switch (level) {
        case LogLevel.Error:
          console.error(message)
          return
        case LogLevel.Info:
          console.info(message)
          return
        case LogLevel.Verbose:
          console.debug(message)
          return
        case LogLevel.Warning:
          console.warn(message)
          return
        default:
          return
      }
    },
  },
}

const clientId = import.meta.env.DEV
  ? 'fd55a80c-3448-4b39-9661-08c38650e25e'
  : '7908cd69-6ae5-4025-ae43-e986b87bba25'

// Msal Configurations
export const msalConfig = {
  auth: {
    clientId: clientId,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    authority: 'https://login.microsoftonline.com/common/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    ...(
      import.meta.env.DEV ? devLogging : {}
    ),
    allowRedirectInIframe: true,
  },
}
